import React from 'react';

const ThemeToggle = ({ isDarkMode, toggleDarkMode }) => {
  const buttonBgClass = isDarkMode ? 'bg-gray-700' : 'bg-blue-700';
  const iconColorClass = isDarkMode ? 'text-yellow-400' : 'text-yellow-300';
  const focusRingClass = isDarkMode ? 'focus:ring-gray-600' : 'focus:ring-blue-600';

  return (
    <button
      onClick={toggleDarkMode}
      className={`p-2 rounded-full focus:outline-none focus:ring-2 transition-colors duration-300 ${buttonBgClass} ${iconColorClass} ${focusRingClass}`}
      aria-label="Toggle dark mode"
    >
      {isDarkMode ? (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.325 6.675l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      ) : (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9 9 0 008.354-5.646z"></path>
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;

// DONE